import React from 'react';

import ErrorIcon from '@atlaskit/icon/utility/migration/error';
import SuccessIcon from '@atlaskit/icon/utility/migration/success--editor-success';

import { FieldId } from '../field';

import { StyledErrorMessage, StyledHelperMessage, StyledValidMessage } from './styled';
import { type EocMessagesProps } from './types';

export const HelperMessage = ({ children }: EocMessagesProps) => {
	return (
		<FieldId.Consumer>
			{(fieldId) => (
				<StyledHelperMessage id={fieldId ? `${fieldId}-helper` : undefined}>
					{children}
				</StyledHelperMessage>
			)}
		</FieldId.Consumer>
	);
};

export const ValidMessage = ({ children }: EocMessagesProps) => {
	return (
		<FieldId.Consumer>
			{(fieldId) => (
				<StyledValidMessage
					id={fieldId ? `${fieldId}-valid` : undefined}
					aria-live="polite"
					aria-atomic="true"
					columnGap="6px"
				>
					<SuccessIcon
						LEGACY_margin="0 -2px 0 0"
						color="currentColor"
						LEGACY_size="small"
						label="success"
					/>
					{children}
				</StyledValidMessage>
			)}
		</FieldId.Consumer>
	);
};

export const ErrorMessage = ({ children }: EocMessagesProps) => {
	return (
		<FieldId.Consumer>
			{(fieldId) => (
				<StyledErrorMessage
					id={fieldId ? `${fieldId}-error` : undefined}
					aria-live="polite"
					aria-atomic="true"
					columnGap="6px"
				>
					<ErrorIcon
						LEGACY_margin="0 -2px 0 0"
						color="currentColor"
						LEGACY_size="small"
						label="error"
					/>
					{children}
				</StyledErrorMessage>
			)}
		</FieldId.Consumer>
	);
};
